import { graphql } from "@opensea/graphql"
import {
  dropStoreCollectionFragment,
  dropStoreDropFragment,
} from "@/components/collection/drops/drop-store"
import { SetDropReminderModalFragment } from "../SetDropReminderModal"

export const CollectionDropProviderCollectionFragment = graphql(
  `
    fragment CollectionDropProvider_collection on Collection {
      slug
      ...dropStore_collection
    }
  `,
  [dropStoreCollectionFragment],
)

export const CollectionDropProviderDropFragment = graphql(
  `
    fragment CollectionDropProvider_drop on Drop {
      ...dropStore_drop
      ...SetDropReminderModal
    }
  `,
  [dropStoreDropFragment, SetDropReminderModalFragment],
)
